import "@/App.css";
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import ErrorBoundary from "@/components/ErrorBoundary";
import { LanguageProvider, useLang } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import SmoothScroll from "@/components/SmoothScroll";
import CookieBanner from "@/components/CookieBanner";
import Home from "@/pages/Home";
import VehiclesPage from "@/pages/VehiclesPage";
import VehicleDetail from "@/pages/VehicleDetail";
import AutoAbo from "@/pages/AutoAbo";
import Finanzierung from "@/pages/Finanzierung";
import Ankauf from "@/pages/Ankauf";
import Mietwagen from "@/pages/Mietwagen";
import Service from "@/pages/Service";
import VerkaufteFahrzeuge from "@/pages/VerkaufteFahrzeuge";
import UeberUns from "@/pages/UeberUns";
import Leistungen from "@/pages/Leistungen";
import Kontakt from "@/pages/Kontakt";
import Karriere from "@/pages/Karriere";
import KarriereJob from "@/pages/KarriereJob";
import NotFound from "@/pages/NotFound";
import { Impressum, Datenschutz, AGB, Widerruf } from "@/pages/Legal";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";

function PageRoutes() {
  const location = useLocation();
  return (
    <div key={location.pathname} className="page-fade">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/fahrzeuge" element={<VehiclesPage />} />
        <Route path="/fahrzeug/:id" element={<VehicleDetail />} />
        <Route path="/auto-abo" element={<AutoAbo />} />
        <Route path="/finanzierung" element={<Finanzierung />} />
        <Route path="/ankauf" element={<Ankauf />} />
        <Route path="/inzahlungnahme" element={<Ankauf mode="inzahlung" />} />
        <Route path="/mietwagen" element={<Mietwagen />} />
        <Route path="/service" element={<Service />} />
        <Route path="/verkaufte-fahrzeuge" element={<VerkaufteFahrzeuge />} />
        <Route path="/ueber-uns" element={<UeberUns />} />
        <Route path="/leistungen" element={<Leistungen />} />
        <Route path="/kontakt" element={<Kontakt />} />
        <Route path="/karriere" element={<Karriere />} />
        <Route path="/karriere/:slug" element={<KarriereJob />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/agb" element={<AGB />} />
        <Route path="/widerruf" element={<Widerruf />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

// Setzt die Sprache anhand des URL-Präfixes (/en/*, /es/*)
function LangGate({ lang }) {
  const { lang: current, setLang } = useLang();
  useEffect(() => {
    if (current !== lang) setLang(lang);
  }, [lang, current, setLang]);
  return <PageRoutes />;
}

function App() {
  return (
    <ErrorBoundary>
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
          <SmoothScroll>
            <Routes>
              <Route path="/en/*" element={<LangGate lang="en" />} />
              <Route path="/es/*" element={<LangGate lang="es" />} />
              <Route path="/*" element={<PageRoutes />} />
            </Routes>
            <CookieBanner />
          </SmoothScroll>
          <Toaster
            position="bottom-center"
            theme="dark"
            toastOptions={{
              style: { background: "#0f0f0f", border: "1px solid rgba(255,255,255,0.1)", color: "#fff" },
            }}
          />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
    </ErrorBoundary>
  );
}

export default App;
